/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-15 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function AIIcon(props) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.2" width="32" height="32" rx="16" fill="#F9B23A" />
      <rect opacity="0.3" x="2" y="2" width="28" height="28" rx="14" fill="#F9B23A" />
      <rect x="4" y="4" width="24" height="24" rx="12" fill="url(#paint0_linear_17418_16728)" />
      <path
        d="M14.2 9L15.6848 11.7152L18.4 13.2L15.6848 14.6848L14.2 17.4L12.7152 14.6848L10 13.2L12.7152 11.7152L14.2 9Z"
        fill="white"
      />
      <path
        d="M19 14.3999L20.0608 16.6623L22 17.8999L20.0608 19.1375L19 21.3999L17.9392 19.1375L16 17.8999L17.9392 16.6623L19 14.3999Z"
        fill="white"
      />
      <path
        d="M14.1999 18.3999L14.8364 19.7573L15.9999 20.4999L14.8364 21.2425L14.1999 22.5999L13.5634 21.2425L12.3999 20.4999L13.5634 19.7573L14.1999 18.3999Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_17418_16728"
          x1="16"
          y1="4"
          x2="16"
          y2="28"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFCD77" />
          <stop offset="1" stopColor="#EC9707" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function MagicIcon(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.50098 1.25293L9.15816 4.28324L12.1885 5.94043L9.15816 7.59762L7.50098 10.6279L5.84379 7.59762L2.81348 5.94043L5.84379 4.28324L7.50098 1.25293Z"
        fill="#F48D32"
      />
      <path
        d="M14.0643 9.06641L15.1693 11.0864L17.1893 12.1914L15.1693 13.2964L14.0643 15.3164L12.9593 13.2964L10.9393 12.1914L12.9593 11.0864L14.0643 9.06641Z"
        fill="#F48D32"
      />
      <path
        d="M7.50098 15.6289L8.05348 16.6389L9.06348 17.1914L8.05348 17.7439L7.50098 18.7539L6.94848 17.7439L5.93848 17.1914L6.94848 16.6389L7.50098 15.6289Z"
        fill="#F48D32"
      />
    </svg>
  );
}
